import React from "react";
import { ButtonProps, Button } from "../button/Button";
import { colors } from "../colors/color";
import { Flex } from "../compositeComponents/FlexHelpers";
import { iconName, Icon } from "../icons/Icons";
import { Small } from "../typography/Body";

export function ListItemWithSubLines(props:{
    leadingIcon:iconName,
    primaryText:string,
    secondaryItems:{
        leadingIcon:iconName,
        text:string
    }[],
    button?:ButtonProps
}):JSX.Element
{
    return (
        <Flex gap={16} alignItems="center" justifyContent="flex-start" width="100%">

            <Flex flexDirection="column">
                <Flex alignItems="center" gap={8}>
                    <Icon name={props.leadingIcon} color={colors.icon.default} size="small" />                            
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" gap={4} style={{ minWidth: 0, flex: 1 }}>
                
                <Flex gap={4} style={{ minWidth: 0, width: "100%" }}>
                    <span style={{ display: "block", minWidth: 0, flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {props.primaryText}
                    </span>
                </Flex>

                {props.secondaryItems.map((item, index) => (
                    <Flex key={index} gap={4} style={{ minWidth: 0, width: "100%" }}>
                        <Icon name={item.leadingIcon} size="x-small" />
                        <Small style={{ display: "block", minWidth: 0, flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {item.text}
                        </Small>
                    </Flex>
                ))}

            </Flex>

            {props.button &&
                <Button {...props.button} />
            }
        </Flex>
    );
}